var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.493,
    height: 16.102,
    viewBox: "0 0 20.493 16.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(-6.4 -25.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M17.808,26.031a1.464,1.464,0,0,1,2.07,0l6.587,6.587a1.464,1.464,0,0,1,0,2.07l-6.587,6.587a1.464,1.464,0,1,1-2.07-2.07l3.963-4.088H7.864a1.464,1.464,0,1,1,0-2.928H21.77L17.808,28.1A1.464,1.464,0,0,1,17.808,26.031Z",
    transform: "translate(0)",
    fill: "#0f0f0f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f2ae27ade6aa367db04eda34114356e7.svg";
export { ForwardRef as ReactComponent };